<template>
    <div>
        <div class='quantity-container'>
            <!-- <div class='successfully-added-to-bag-container'>
                <Tooltip :tooltip_queue='tooltip_queue'/>
            </div> -->
            <!-- <div class='out-of-stock-container'>
                <OutOfStockAlert :stock='stock'/>
            </div> -->
            <input class='quantity-text-box' type="text" id="quantity" name="quantity" v-model='quantity' @blur='blurQuantity'>
            <div class='quantity-buttons-container'>
                <div @click='addQuantity' class='change-quantity-button no-highlight'>+</div>
                <div @click='removeQuantity' class='change-quantity-button no-highlight'>-</div>
            </div>
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import OutOfStockAlert from '@/ecom/components/cart/OutOfStockAlert.vue';
import Tooltip from '@/ecom/components/popups/Tooltip.vue';

export default {
    components: {OutOfStockAlert, Tooltip},
    props: ['item_quantity', 'product', 'update_cart'],
    emits: ['updatedCartListener', 'updatedQuantityListener'],
    data(){
        return{
            quantity: this.item_quantity,
            stock: {},
            tooltip_queue: []
        }
    },
    methods:{
        addQuantity(){
            this.quantity++;
            this.updateQuantity();
        },
        removeQuantity(){
            if(this.quantity > 1){
                this.quantity--;
                this.updateQuantity();
            }
        },
        blurQuantity(){
            if(this.quantity == ''){
                this.quantity = 1;
            }
        
            this.updateQuantity()
        },
        updateQuantity(){
            if(this.update_cart){
                this.updateCart();
            }
            else{
                this.$emit('updatedQuantityListener', this.quantity);
            }
        },
        async updateCart(type){
            let response = await fetch(`/api/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.product,
                   quantity: this.quantity,
                   type: 'override_quantity'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.stock = results.stock;

                if(!results.stock.in_stock){
                    this.quantity = this.item_quantity;
                }

                if(!this.stock.in_stock) {
                    let out_of_stock_message = '';
                    if(this.stock.left_in_stock > 0) {
                        out_of_stock_message = 'There are only ' + this.stock.left_in_stock  + ' of this item left in stock';
                    } else if(this.stock.left_in_stock == 0){
                        out_of_stock_message = 'This item is out of stock';
                    }
                    this.tooltip_queue.push({text: out_of_stock_message});
                }

                this.$emit('updatedCartListener', this.product);
            }
        }
    },
    watch: {
        'item_quantity' : function() {
            this.quantity = this.item_quantity;
        }
    }
}
</script>

<style lang="scss" scoped>
.quantity-container{
    display: flex;
    //justify-content: center;
}

.change-quantity-button no-highlight {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
 
.change-quantity-button{
    border: 1px solid #dee2e6;
    height: 19px;
    width: 19px;
    cursor: pointer;
}

.minus-button{
    border-radius: 4px 0px 0px 4px;
}

.plus-button{
    border-radius: 0px 4px 4px 0px;
}

.quantity-text-box{
    width: 40px;
    height: 38px;
    text-align: center;
    border-top: solid 1px #dee2e6;
    border-left: none;
    border-right: none;
    border: 1px solid #dee2e6;
    outline: none;
}

.quantity-text-box:focus{
     outline: none;
}

.out-of-stock-container{
    position: absolute;
    margin-top: 40px;
}

</style>